/* ============
 * Font Awesome
 * ============
 *
 * Font Awesome gives you scalable vector icons that can instantly
 * be customized — size, color, drop shadow, and anything that can
 * be done with the power of CSS.
 *
 * http://fontawesome.io/
 */

// import 'font-awesome/css/font-awesome.css';
// import fontawesome from '@fortawesome/fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faEye,
  faEdit,
  faSlidersH,
  faTimesCircle,
  faInfoCircle,
  faChevronDown,
  faChevronUp,
  faSpinner,
  faCircle,
  faBuilding,
  faEnvelope,
  faCopy,
  faUsers,
  faBriefcase,
  faBook,
  faListOl,
  faFile,
  faFileAudio,
  faFileExcel,
  faFileImage,
  faFilePdf,
  faFileWord,
  faFileVideo,
  faFileArchive,
  faTable,
  faSquare,
  faFolder,
  faUniversity,
  faChevronRight,
  faCheckCircle,
  faFileExport,
  faPlusCircle,
  faCalendarAlt,
  faQuestionCircle,
  faClock,
  faLightbulb,
  faComment,
  faProjectDiagram,
  faNewspaper,
  faArrowUp,
  faMedal,
  faUpload,
  faMoneyBill,
  faIdCard,
  faMoneyCheck,
  faTags,
  faAlignJustify,
  faSortAmountDown,
  faRedo,
  faFlagCheckered,
  faUserLock,
  faCompressArrowsAlt,
  faExpandArrowsAlt,
  faPhone,
  faMobileAlt,
  faSort,
  faCopyright,
  faParagraph,
  faLink,
  faStar,
  faEllipsisH,
  faSnowflake,
  faHome,
  faFileImport,
  faLayerGroup,
  faExclamationTriangle,
  faCheck,
  faMap,
  faCalendar,
  faRetweet,
  faDownload,
  faTimes,
  faPlus,
  faArrowLeft,
  faTrashAlt,
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faEye,
  faEdit,
  faSlidersH,
  faTimesCircle,
  faInfoCircle,
  faChevronDown,
  faChevronUp,
  faSpinner,
  faCircle,
  faBuilding,
  faEnvelope,
  faCopy,
  faUsers,
  faBriefcase,
  faBook,
  faListOl,
  faFile,
  faFileAudio,
  faFileExcel,
  faFileImage,
  faFilePdf,
  faFileWord,
  faFileVideo,
  faFileArchive,
  faTable,
  faSquare,
  faFolder,
  faUniversity,
  faChevronRight,
  faCheckCircle,
  faFileExport,
  faPlusCircle,
  faCalendarAlt,
  faQuestionCircle,
  faClock,
  faLightbulb,
  faComment,
  faProjectDiagram,
  faNewspaper,
  faArrowUp,
  faMedal,
  faUpload,
  faMoneyBill,
  faIdCard,
  faMoneyCheck,
  faTags,
  faAlignJustify,
  faSortAmountDown,
  faRedo,
  faFlagCheckered,
  faUserLock,
  faCompressArrowsAlt,
  faExpandArrowsAlt,
  faPhone,
  faMobileAlt,
  faSort,
  faCopyright,
  faParagraph,
  faLink,
  faStar,
  faEllipsisH,
  faSnowflake,
  faHome,
  faFileImport,
  faLayerGroup,
  faExclamationTriangle,
  faCheck,
  faMap,
  faCalendar,
  faRetweet,
  faDownload,
  faTimes,
  faPlus,
  faArrowLeft,
  faTrashAlt,
);



// WEBPACK FOOTER //
// ./src/plugins/font-awesome.js